<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <h5 class="mb-0">Channels</h5>
      </div>
    </div>
    <div class="trezo-card-content">
      <div
        class="flex items-center justify-between border-b border-gray-100 dark:border-[#172036] pb-[14px] mb-[14px] last:border-none last:mb-0 last:pb-0"
      >
        <div class="flex items-center gap-[15px]">
          <img src="@/assets/images/icons/facebook3.svg" alt="facebook" />
          <div>
            <span class="block font-semibold text-black dark:text-white">
              Facebook
            </span>
            <span class="block text-xs mt-px"> Community </span>
          </div>
        </div>
        <div class="w-[150px]">
          <div class="leading-none flex items-center gap-[12px]">
            <div
              class="flex w-full h-[8px] overflow-hidden rounded-md bg-primary-100 dark:bg-[#172036]"
            >
              <div
                class="flex flex-col justify-center overflow-hidden bg-primary-400 rounded-md"
                style="width: 50%"
              ></div>
            </div>
            <span class="block text-xs"> 50% </span>
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-between border-b border-gray-100 dark:border-[#172036] pb-[14px] mb-[14px] last:border-none last:mb-0 last:pb-0"
      >
        <div class="flex items-center gap-[15px]">
          <img src="@/assets/images/icons/dribbble2.svg" alt="dribbble" />
          <div>
            <span class="block font-semibold text-black dark:text-white">
              Dribbble
            </span>
            <span class="block text-xs mt-px"> Community </span>
          </div>
        </div>
        <div class="w-[150px]">
          <div class="leading-none flex items-center gap-[12px]">
            <div
              class="flex w-full h-[8px] overflow-hidden rounded-md bg-secondary-100 dark:bg-[#172036]"
            >
              <div
                class="flex flex-col justify-center overflow-hidden bg-secondary-400 rounded-md"
                style="width: 75%"
              ></div>
            </div>
            <span class="block text-xs"> 75% </span>
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-between border-b border-gray-100 dark:border-[#172036] pb-[14px] mb-[14px] last:border-none last:mb-0 last:pb-0"
      >
        <div class="flex items-center gap-[15px]">
          <img src="@/assets/images/icons/instagram2.svg" alt="instagram" />
          <div>
            <span class="block font-semibold text-black dark:text-white">
              Instagram
            </span>
            <span class="block text-xs mt-px"> Reels </span>
          </div>
        </div>
        <div class="w-[150px]">
          <div class="leading-none flex items-center gap-[12px]">
            <div
              class="flex w-full h-[8px] overflow-hidden rounded-md bg-orange-100 dark:bg-[#172036]"
            >
              <div
                class="flex flex-col justify-center overflow-hidden bg-orange-400 rounded-md"
                style="width: 30%"
              ></div>
            </div>
            <span class="block text-xs"> 30% </span>
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-between border-b border-gray-100 dark:border-[#172036] pb-[14px] mb-[14px] last:border-none last:mb-0 last:pb-0"
      >
        <div class="flex items-center gap-[15px]">
          <img src="@/assets/images/icons/behance.svg" alt="behance" />
          <div>
            <span class="block font-semibold text-black dark:text-white">
              Behance
            </span>
            <span class="block text-xs mt-px"> Community </span>
          </div>
        </div>
        <div class="w-[150px]">
          <div class="leading-none flex items-center gap-[12px]">
            <div
              class="flex w-full h-[8px] overflow-hidden rounded-md bg-purple-100 dark:bg-[#172036]"
            >
              <div
                class="flex flex-col justify-center overflow-hidden bg-purple-400 rounded-md"
                style="width: 80%"
              ></div>
            </div>
            <span class="block text-xs"> 80% </span>
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-between border-b border-gray-100 dark:border-[#172036] pb-[14px] mb-[14px] last:border-none last:mb-0 last:pb-0"
      >
        <div class="flex items-center gap-[15px]">
          <img src="@/assets/images/icons/figma2.svg" alt="figma" />
          <div>
            <span class="block font-semibold text-black dark:text-white">
              Figma
            </span>
            <span class="block text-xs mt-px"> Community </span>
          </div>
        </div>
        <div class="w-[150px]">
          <div class="leading-none flex items-center gap-[12px]">
            <div
              class="flex w-full h-[8px] overflow-hidden rounded-md bg-info-100 dark:bg-[#172036]"
            >
              <div
                class="flex flex-col justify-center overflow-hidden bg-info-400 rounded-md"
                style="width: 50%"
              ></div>
            </div>
            <span class="block text-xs"> 50% </span>
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-between border-b border-gray-100 dark:border-[#172036] pb-[14px] mb-[14px] last:border-none last:mb-0 last:pb-0"
      >
        <div class="flex items-center gap-[15px]">
          <img src="@/assets/images/icons/google3.svg" alt="google" />
          <div>
            <span class="block font-semibold text-black dark:text-white">
              Google
            </span>
            <span class="block text-xs mt-px"> SEO & PPC </span>
          </div>
        </div>
        <div class="w-[150px]">
          <div class="leading-none flex items-center gap-[12px]">
            <div
              class="flex w-full h-[8px] overflow-hidden rounded-md bg-success-100 dark:bg-[#172036]"
            >
              <div
                class="flex flex-col justify-center overflow-hidden bg-success-400 rounded-md"
                style="width: 20%"
              ></div>
            </div>
            <span class="block text-xs"> 20% </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ChannelsContent",
});
</script>
